import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
	previewWrapper: {
		display: 'flex',
		flexDirection: 'row',
	},
	imgWrapper: {
		width: 95,
		height: 95,
		minWidth: 95,
		backgroundSize: 'cover',
		backgroundPosition: 'center',
	},
	bodyWrapper: {
		paddingTop: theme.spacing(0.5),
		paddingBottom: theme.spacing(0.5),
		paddingLeft: theme.spacing(1),
		paddingRight: theme.spacing(1),
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'stretch',
		flexDirection: 'column',
		backgroundColor: theme.palette.background.paper,
		flex: 1,
	},
	headerStyle: {
		color: theme.palette.text.primary,
		fontWeight: '600',
		fontSize: '0.8rem',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		paddingBottom: theme.spacing(0),
	},
	descriptionStyle: {
		color: theme.palette.text.primary,
		fontSize: '0.75rem',
		lineHeight: '120%',
		overflow: 'hidden',
		lineClamp: 3,
		'-webkit-line-clamp': 3 /* number of lines to show */,
		'-webkit-box-orient': 'vertical',
		display: '-webkit-box',
		textOverflow: 'ellipsis',
		paddingTop: theme.spacing(1),
		marginBottom: theme.spacing(1),
	},
	urlStyle: {
		color: theme.palette.text.secondary,
		fontSize: '0.6rem',
		overflow: 'hidden',
		lineHeight: '120%',
		wordBreak: 'break-all',
		textOverflow: 'ellipsis',
	},
}));

const SEOPreview = ({ header, description, media, url, classes: classesProps = {} }) => {
	const classes = useStyles();

	return (
		<div className={`${classes.previewWrapper} ${classesProps.root}`}>
			<div
				className={`${classes.imgWrapper} ${classesProps.media}`}
				style={{ backgroundImage: `url(${media})` }}
			/>

			<div className={`${classes.bodyWrapper} ${classesProps.content}`}>
				<Typography
					variant="body1"
					classes={{ root: `${classes.headerStyle} ${classesProps.header}` }}
				>
					{header}
				</Typography>
				<Typography
					variant="body2"
					classes={{ root: `${classes.descriptionStyle} ${classesProps.description}` }}
				>
					{description}
				</Typography>
				<Typography
					variant="caption"
					classes={{ root: `${classes.urlStyle} ${classesProps.url}` }}
				>
					{url?.replace(/^(http|https?|ftp):\/\//, '') || false}
				</Typography>
			</div>
		</div>
	);
};

SEOPreview.propTypes = {
	media: PropTypes.string,
	header: PropTypes.string,
	description: PropTypes.string,
	url: PropTypes.string,
	classes: PropTypes.object,
};

export default SEOPreview;
